module.exports = __webpack_public_path__ + "img/19_47.5f40a52b.png";